import { Link as RouterLink, useMatches } from 'react-router-dom'
import MUIBreadcrumbs from '@mui/material/Breadcrumbs'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import type { Params } from 'react-router-dom'

export type BreadcrumbHandle = {
    breadcrumb: (args: {
        params: Params
        data?: unknown
    }) => string
}

export default function Breadcrumbs() {
    const matches = useMatches()

    const crumbs = matches
        .filter(
            (match): match is typeof match & { handle: BreadcrumbHandle } =>
                typeof match.handle === 'object' &&
                match.handle !== null &&
                'breadcrumb' in match.handle
        )
        .map(match => ({
            label: match.handle.breadcrumb({
                params: match.params,
                data: match.data,
            }),
            to: match.pathname,
        }))

    return (
        <MUIBreadcrumbs
            aria-label="breadcrumb"
            separator="›"
            sx={{
                color: 'text.secondary',
            }}
        >
            {crumbs.map((crumb, index) => {
                const isLast = index === crumbs.length - 1

                return isLast ? (
                    <Typography
                        key={crumb.to}
                        variant="body2"
                        fontWeight={500}
                        color="text.primary"
                    >
                        {crumb.label}
                    </Typography>
                ) : (
                    <Link
                        key={crumb.to}
                        component={RouterLink}
                        to={crumb.to}
                        underline="hover"
                        sx={{ textDecorationColor: 'transparent' }}
                    >
                        <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                                '&:hover': {
                                    color: 'text.primary',
                                },
                            }}
                        >
                            {crumb.label}
                        </Typography>
                    </Link>
                )
            })}
        </MUIBreadcrumbs>
    )
}
